import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useSelector } from "react-redux";
import {
  DealerLocation,
  Feature,
  LocationPart,
  LocationWholegood,
  MatchedProduct,
  PricingType,
  SetupType,
} from "../../../models/features/Integration/DmsSetup";
import { AppState } from "../../../redux/reducer/rootReducer";
import AppGrid from "../../app/AppGrid";
import AppConfirmDialog from "../../app/AppConfirmDialog";
import { useDispatch } from "react-redux";
import {
  addBulkMatchedParts,
  addBulkMatchedWholegoods,
  addMatchedProduct,
  removeAllDmsParts,
  removeAllDmsWhoolegoods,
  removeDmsParts,
  removeDmsWhoolegoods,
  removeMatchPart,
  removeMatchedProduct,
  useReInitiateSetupMutation,
  useSetIsSyncingV2Mutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useGetProductByIdMutation } from "../../../redux/reducer/features/Product/productSlice";
import PageLoader from "../../app/PageLoader";
import { Product } from "../../../models/features/Product/Product";
import { TabContext, TabPanel } from "@mui/lab";
import { AppGridId } from "../../../models/app/AppGridModels";
import {
  GetAppGridColumns,
  filterColumnsBySetupType,
} from "../../../services/utilities/utility";
import { Dispatch } from "@reduxjs/toolkit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import TruncatedCellWithTooltip from "../../common/TruncatedCellWithTooltip";
import ProductDetail from "../DmsSetup/Popup/ProductDetail";
import MatchManually from "../DmsSetup/Popup/MatchManually";
import { setProductTypes } from "../../../redux/reducer/features/Auth/authSlice";
import { hasFeatureAccess } from "../../../services/featurePermissions/featureMatrix";

interface ReInitiateShopifyProps {
  handleBack: any;
  locations: DealerLocation[];
  productType?: any;
  setTabValue?: any;
}

const ReInitiateShopify: React.FunctionComponent<ReInitiateShopifyProps> = ({
  handleBack,
  locations,
  productType,
  setTabValue,
}) => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Create_Setup_Shopify_Initialization,
    ),
  );

  const dispatch = useDispatch<Dispatch<any>>();
  const partsPortalSetting = useSelector(
    (state: AppState) => state.shoppingPortalReducer,
  );
  const { typeToProcess } = useSelector((state: AppState) => state.dmsReducer);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [reInitiateSetupFailed, setReInitiateSetupFailed] =
    React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState<Product>();
  const [selectedItem, setSelectedItem] = React.useState<MatchedProduct>();
  const [selectedPartItem, setSelectedPartItem] =
    React.useState<LocationPart>();
  const [stock, setstock] = React.useState<any>([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedPartRows, setSelectedPartRows] = React.useState([]);
  const [Formopen, setFormOpen] = React.useState(false);
  const { matchedWholegoods, matchedParts } = useSelector(
    (state: AppState) => state.dmsReducer,
  );
  const setupType = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.setupType,
  );
  const whoolegoods = matchedWholegoods.filter((n) => n.dmsProduct);
  const parts = matchedParts.filter((n) => n.dmsPart);
  const [value, setValue] = React.useState("Wholegoods");
  const { dealerId } = useSelector((state: AppState) => state.authReducer);
  const [priceType, setPriceType] = React.useState(PricingType.Price);
  const [anchorElWG, setAnchorElWG] = React.useState<null | HTMLElement>(null);
  const openWGMenu = Boolean(anchorElWG);
  const [anchorElParts, setAnchorElParts] = React.useState<null | HTMLElement>(
    null,
  );
  const openPartsMenu = Boolean(anchorElParts);
  const [popup, setPopup] = React.useState(false);
  const [selectedRowData, setSelectedRowData] =
    React.useState<LocationWholegood[]>();
  const [finishConfirmOpen, setFinishConfirmOpen] = React.useState(false);
  const [syncStartedDialog, setSyncStartedDialog] = React.useState(false);

  const [reInitiateSetupMutation, reInitiateSetupMutationResult] =
    useReInitiateSetupMutation();
  const [setSyncingMutation, setSyncingMutationResult] =
    useSetIsSyncingV2Mutation();
  const onDialogClose = () => {
    setConfirmDialog(false);
  };
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductByIdMutation();
  const onDialogSuccess = () => {
    if (whoolegoods.length > 0) {
      dispatch(removeMatchedProduct(selectedItem as MatchedProduct));
      dispatch(
        removeDmsWhoolegoods({
          inventoryModelId: selectedItem?.dmsProduct
            ?.inventoryModelId as string,
        }),
      );
    } else if (parts.length > 0) {
      dispatch(
        removeMatchPart({
          inventoryPartId: selectedPartItem?.inventoryPartId as string,
        }),
      );
      dispatch(
        removeDmsParts({
          inventoryPartId: selectedPartItem?.inventoryPartId as string,
        }),
      );
    }
    setConfirmDialog(false);
  };

  const handleClose = () => {
    setFormOpen(false);
    setFinishConfirmOpen(false);
  };

  const handleWGEditViewClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElWG(event.currentTarget);
  };
  const handleWGEditViewClose = () => {
    setAnchorElWG(null);
  };

  const handlePartsEditViewClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElParts(event.currentTarget);
  };
  const handlePartsEditViewClose = () => {
    setAnchorElParts(null);
  };

  const handlePopupClose = () => {
    setSelectedRowData([]);
    setPopup(false);
  };

  const Products: MatchedProduct[] = [];

  const handleFinish = async () => {
    try {
      Products.length = 0;
      productType === 0
        ? whoolegoods.forEach((values: any) => Products.push(values))
        : parts.forEach((values: any) => Products.push(values));

      const res: any = await reInitiateSetupMutation({
        data: {
          matchingProducts: Products,
          productTypes: typeToProcess,
          dealerId: dealerId ?? "",
        },
      });

      if (res.data && res.data.status === 0) {
        await setSyncingMutation({
          pricing: priceType,
          dmsSetupId: res.data.entity.id ?? "",
          setSyncing: true,
          productType: productType,
        });
      }

      productType === 0
        ? dispatch(addBulkMatchedWholegoods([]))
        : dispatch(addBulkMatchedParts([]));

      dispatch(removeAllDmsWhoolegoods());
      dispatch(removeAllDmsParts());
    } catch (error) {
      console.error("Error in handleFinish:", error);
    }
  };

  const handleFinishSync = () => {
    setFinishConfirmOpen(false);
    handleFinish();
  };

  React.useEffect(() => {
    setValue(productType === 0 ? "Wholegoods" : "Parts");
  }, [productType]);

  React.useEffect(() => {
    if (productByIdMutationResult.isSuccess) {
      setSelectedProduct(productByIdMutationResult.data.entity);
    }
  }, [productByIdMutationResult]);

  React.useEffect(() => {
    if (
      reInitiateSetupMutationResult.isSuccess &&
      reInitiateSetupMutationResult.data?.status === 0
    ) {
      dispatch(
        setProductTypes(
          reInitiateSetupMutationResult.data?.entity?.productTypes ?? [],
        ),
      );
    } else if (
      reInitiateSetupMutationResult.data?.status === 10 ||
      reInitiateSetupMutationResult.isError
    ) {
      setReInitiateSetupFailed(true);
    }
  }, [reInitiateSetupMutationResult]);

  React.useEffect(() => {
    if (
      setSyncingMutationResult.isSuccess &&
      setSyncingMutationResult.data?.status === 200
    ) {
      setSyncStartedDialog(true);
    }
  }, [setSyncingMutationResult]);

  const columns: GridColDef[] = [
    {
      field: "dmsProduct.mfgName",
      headerName: "Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.dmsProduct.mfgName,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <TruncatedCellWithTooltip value={params.row.dmsProduct.mfgName} />
        );
      },
    },
    {
      field: "catalogProduct.modelNumber",
      headerName: "Catalog Model Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.modelNumber
          : "N/A",
      renderCell: (params: GridRenderCellParams) => {
        const modelNumber = params.row.catalogProduct
          ? params.row.catalogProduct?.modelNumber
          : "N/A";
        return <TruncatedCellWithTooltip value={modelNumber} />;
      },
    },
    {
      field: "dmsProduct.model",
      headerName: "Dms Model",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <TruncatedCellWithTooltip value={params.row.dmsProduct?.model} />
        );
      },
    },
    {
      field: "catalogProduct.title",
      headerName: "Title",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        const title = params.row.catalogProduct
          ? params.row.catalogProduct?.title
          : params.row.dmsProduct?.mfrCode + " " + params.row.dmsProduct?.model;
        return <TruncatedCellWithTooltip value={title} />;
      },
    },
    {
      field: "catalogProduct.sku",
      headerName: "Catalog SKU",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.catalogProduct ? params.row.catalogProduct?.sku : "N/A",
      renderCell: (params: GridRenderCellParams) => {
        const sku = params.row.catalogProduct
          ? params.row.catalogProduct?.sku
          : "N/A";
        return <TruncatedCellWithTooltip value={sku} />;
      },
    },
    {
      field: "catalogProduct.category.title",
      headerName: "Category",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.category?.title
          : params.row.dmsProduct.productLine,
      renderCell: (params: GridRenderCellParams) => {
        const categoryTitle = params.row.catalogProduct
          ? params.row.catalogProduct?.category?.title
          : params.row.dmsProduct.productLine;
        return <TruncatedCellWithTooltip value={categoryTitle} />;
      },
    },
    {
      field: "dmsProduct.price",
      headerName: "MSRP ($)",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct?.price.toFixed(2),
    },
    {
      field: "dmsProduct.count",
      headerName: "Stock",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) => {
        if (params.row?.dmsProduct.locationCount) {
          return params.row?.dmsProduct.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0,
          );
        } else {
          return 0;
        }
      },
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      align: "center",
      headerAlign: "center",
      filterable: false,
      disableExport: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.catalogProduct ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : (
          <Chip label="DMS" color="warning" size="small" />
        );
      },
    },
    {
      field: "editView",
      type: "editView",
      headerName: "Edit/View",
      align: "center",
      headerAlign: "center",
      flex: 1,
      disableExport: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Chip
            label="Action"
            color="info"
            clickable
            onClick={(e) => {
              setSelectedItem(params.row);
              handleWGEditViewClick(e);
            }}
          />
        );
      },
    },
  ];

  const partColumns: GridColDef[] = [
    {
      field: "mfrName",
      headerName: "Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.mfrName,
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.partNumber,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.description,
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      flex: 1,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "availableQty",
      headerName: "Stock",
      flex: 1,
      filterable: false,
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.availableQty,
    },
    {
      field: "editView",
      type: "editView",
      headerName: "Edit/View",
      align: "center",
      headerAlign: "center",
      flex: 1,
      disableExport: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Chip
            label="Action"
            color="info"
            clickable
            onClick={(e) => {
              setSelectedPartItem(params.row);
              handlePartsEditViewClick(e);
            }}
          />
        );
      },
    },
  ];
  return (
    <>
      <PageLoader
        isLoading={
          reInitiateSetupMutationResult.isLoading ||
          setSyncingMutationResult.isLoading
        }
      ></PageLoader>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
        p={0.5}
      >
        <Alert severity="info">
          You can sync all {productType === 0 ? "wholegoods" : "parts"} to your
          website or remove items you are not ready to send.
        </Alert>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button size="small" variant="outlined" onClick={handleBack}>
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={!(whoolegoods.length > 0 || parts.length > 0)}
            onClick={() => setFinishConfirmOpen(true)}
          >
            Finish
          </Button>
        </Box>
      </Box>
      {reInitiateSetupFailed === true ? (
        <Alert
          sx={{ mt: 2 }}
          severity="error"
          onClose={() => {
            setReInitiateSetupFailed(false);
          }}
        >
          Error occured while reInitiate your setup
        </Alert>
      ) : (
        ""
      )}

      <Box>
        <TabContext value={value.toString()}>
          <TabPanel value="Wholegoods" style={{ padding: 0 }}>
            <AppGrid
              gridId={AppGridId.Create_Setup_Shopify_Initialization}
              data={whoolegoods.map((item, index) => ({
                id: index,
                ...item,
              }))}
              columns={GetAppGridColumns(
                filterColumnsBySetupType(
                  columns,
                  setupType ?? SetupType.Shopify,
                ),
                gridSetting?.columnVisibilityModel,
              )}
              isLoading={false}
              selectedRows={selectedRows}
              onSelect={(newSelection: any) => {
                setSelectedRows(newSelection);
              }}
              checkBox={true}
              height="60vh"
            ></AppGrid>
          </TabPanel>
          <TabPanel value="Parts" style={{ padding: 0 }}>
            <AppGrid
              data={parts
                .map((n) => n.dmsPart)
                .map((item, index) => ({
                  id: index,
                  ...item,
                }))}
              columns={partColumns}
              isLoading={false}
              checkBox={true}
              selectedRows={selectedPartRows}
              onSelect={(newSelection: any) => {
                setSelectedPartRows(newSelection);
              }}
              height="60vh"
            ></AppGrid>
          </TabPanel>
        </TabContext>
      </Box>

      <AppConfirmDialog
        headerText="Are you sure?"
        bodyText="This product will be removed from matched products."
        onFail={onDialogClose}
        onSuccess={onDialogSuccess}
        handleClose={onDialogClose}
        isOpen={confirmDialog}
      />
      <ProductDetail
        isOpen={Formopen}
        handleClose={handleClose}
        productData={selectedProduct}
        Loading={productByIdMutationResult.isLoading}
        locations={locations}
      />
      <Menu
        anchorEl={anchorElWG}
        id="account-menu"
        open={openWGMenu}
        onClose={handleWGEditViewClose}
        onClick={handleWGEditViewClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {hasFeatureAccess(setupType, Feature.ProductsMatchingWithCatalog) &&
          (selectedItem?.catalogProduct ? (
            <>
              <MenuItem
                onClick={() => {
                  setFormOpen(true);
                  productByIdMutation({
                    data: { id: selectedItem?.catalogProduct?.id },
                  });
                  setstock(selectedItem?.dmsProduct?.locationCount);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon />
                </ListItemIcon>
                View
              </MenuItem>
              <MenuItem
                onClick={() => {
                  dispatch(
                    removeMatchedProduct(selectedItem as MatchedProduct),
                  );
                  dispatch(
                    addMatchedProduct({
                      dmsProduct: selectedItem.dmsProduct as LocationWholegood,
                    }),
                  );
                }}
              >
                <ListItemIcon>
                  <PlaylistRemoveIcon />
                </ListItemIcon>
                Unmatch
              </MenuItem>
            </>
          ) : (
            <MenuItem
              onClick={() => {
                if (selectedItem && selectedItem.dmsProduct) {
                  setSelectedRowData([selectedItem.dmsProduct]);
                  setPopup(true);
                }
              }}
            >
              <ListItemIcon>
                <AddCircleOutlineRoundedIcon />
              </ListItemIcon>
              Match to
            </MenuItem>
          ))}
        <MenuItem
          onClick={() => {
            setConfirmDialog(true);
          }}
        >
          <ListItemIcon>
            <HighlightOffRoundedIcon />
          </ListItemIcon>
          Remove
        </MenuItem>
      </Menu>
      <MatchManually
        isOpen={popup}
        setPopup={setPopup}
        handleClose={handlePopupClose}
        selectedDmsItems={selectedRowData}
      ></MatchManually>
      <Dialog open={finishConfirmOpen} onClose={handleClose}>
        <DialogContent>
          Are you sure you want to finish? This will save all selected products
          and send them to your website.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setFinishConfirmOpen(false)}
          >
            No
          </Button>
          <Button size="small" variant="contained" onClick={handleFinishSync}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={syncStartedDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <Typography variant="h6">Syncing Products to Shopify</Typography>
        </DialogTitle>

        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Sync in progress – Products are syncing in the background. You can
            continue using the app.
          </Typography>
          <DialogActions>
            {partsPortalSetting &&
              partsPortalSetting.isPortalEnabled === false && (
                <Button
                  size="medium"
                  variant="contained"
                  onClick={() => {
                    setSyncStartedDialog(false);
                    if (productType === 0) {
                      setTabValue("Parts");
                    } else if (productType === 1) {
                      setTabValue("Wholegoods");
                    }
                  }}
                >
                  Sync {productType === 0 ? "parts" : "wholegoods"}
                </Button>
              )}
            <Button
              size="medium"
              variant="contained"
              onClick={() => {
                setSyncStartedDialog(false);
                window.location.href = "/ManageProducts";
              }}
            >
              Manage products
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Menu
        anchorEl={anchorElParts}
        id="account-menu"
        open={openPartsMenu}
        onClose={handlePartsEditViewClose}
        onClick={handlePartsEditViewClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            setConfirmDialog(true);
          }}
        >
          <ListItemIcon>
            <HighlightOffRoundedIcon />
          </ListItemIcon>
          Remove
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReInitiateShopify;
